//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import Overview from './_components/Overview';
import Message from './_components/Message';
import JobsManagement from './_components/JobsManagement';
import PostJob from './_components/PostJob';
import Info from './_components/Info';

export default {
  name: 'OwnerManage',
  middleware: 'auth',
  head() {
    return {
      title: 'STEP1NE 企業管理者儀表板',
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: 'STEP1NE 企業管理者儀表板',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            'STEP1NE管理者專用控制面板。專為企業主和網站管理者提供的用戶管理、數據分析和網站維護功能。',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content:
            'STEP1NE管理者專用控制面板。專為企業主和網站管理者提供的用戶管理、數據分析和網站維護功能。',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['userStatus']),
    menu() {
      return {
        overview: { label: '公司總覽', component: Overview },
        info: { label: '公司資料', component: Info },
        jobsManagement: {
          label: '職缺管理',
          children: {
            jobsManagement: {
              label: '職缺管理',
              component: JobsManagement,
              active: this.userStatus === 1,
            },
            postJob: {
              label: '刊登職缺',
              component: PostJob,
              active: this.userStatus === 1,
            },
          },
        },
        message: {
          label: '訊息通知',
          component: Message,
          hide: !process.env.isMessageOpen,
        },
      };
    },
  },
};
